import { render, staticRenderFns } from "./step_5.vue?vue&type=template&id=068de24a&scoped=true&"
import script from "./step_5.vue?vue&type=script&lang=js&"
export * from "./step_5.vue?vue&type=script&lang=js&"
import style0 from "./step_5.vue?vue&type=style&index=0&id=068de24a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068de24a",
  null
  
)

export default component.exports